{
  "name": "landlord",
  "version": "v1.17.1246",
  "private": true,
  "scripts": {
    "start": "vite preview",
    "dev": "vite",
    "build": "vite build",
    "test": "npm run test:architecture && vitest run --coverage --coverage.reporter=lcov --pool=threads --maxWorkers=8",
    "test:architecture": "node eslint/architecture-boundaries.test.js",
    "test:coverage": "vitest --coverage",
    "test:ci": "vitest --coverage",
    "test:file": "vitest --coverage=false --silent=true",
    "test:local": "npm run test:architecture && vitest run",
    "format": "prettier --write \"src/**/*.{ts,tsx}\" \"proxy/**/*.{ts,tsx}\"",
    "lint": "eslint \"src/**/*.{ts,tsx}\" \"proxy/**/*.{ts,tsx}\" --fix --max-warnings=0",
    "lint:ci": "eslint \"src/**/*.{ts,tsx}\" \"proxy/**/*.{ts,tsx}\" --max-warnings=0 --cache --cache-strategy content --cache-location .eslintcache",
    "prepare": "cd .. && husky",
    "verify-errors": "tsc --noEmit --incremental false"
  },
  "dependencies": {
    "@datadog/browser-logs": "^7.7.0",
    "@datadog/browser-rum": "^7.7.0",
    "@datadog/browser-rum-react": "^7.7.0",
    "@datadog/datadog-ci": "^5.21.2",
    "@emotion/react": "^11.14.0",
    "@emotion/styled": "^11.14.1",
    "@hookform/resolvers": "^3.9.1",
    "@mui/icons-material": "^7.3.2",
    "@mui/lab": "^7.0.0-beta.0",
    "@mui/material": "^7.3.2",
    "@mui/system": "^7.3.2",
    "@mui/utils": "^7.3.2",
    "@mui/x-date-pickers": "^8.5.1",
    "@segment/analytics-next": "^1.84.1",
    "@splitsoftware/splitio-react": "^2.6.2",
    "@tanstack/react-query": "^5.101.4",
    "@tanstack/react-query-devtools": "^5.101.4",
    "@tanstack/react-table": "^8.21.3",
    "@tanstack/react-virtual": "^3.14.9",
    "@theguarantors/tg-modern-business": "3.141.0",
    "@theguarantors/tg-package-material-ui": "3.0.0",
    "@vis.gl/react-google-maps": "^1.9.0",
    "autosuggest-highlight": "^3.3.4",
    "axios": "^1.20.0",
    "dayjs": "^1.11.21",
    "deepdash": "^5.3.9",
    "file-saver": "^2.0.5",
    "js-cookie": "3.0.8",
    "json-2-csv": "^5.5.11",
    "libphonenumber-js": "^1.13.10",
    "lodash": "^4.18.1",
    "powerbi-client-react": "^1.4.0",
    "react": "19.2.8",
    "react-dom": "19.2.8",
    "react-dropzone": "^14.4.1",
    "react-error-boundary": "^6.1.2",
    "react-helmet-async": "^3.0.0",
    "react-hook-form": "^7.83.0",
    "react-intersection-observer": "^10.1.0",
    "react-number-format": "^5.4.5",
    "react-places-autocomplete": "^7.3.0",
    "react-router": "8.3.0",
    "userpilot": "^1.4.3",
    "uuid": "^14.0.1",
    "yup": "1.6.1",
    "zod": "^4.6.7",
    "zustand": "^4.4.4"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.5",
    "@faker-js/faker": "^10.5.0",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.0",
    "@testing-library/react": "^16.3.2",
    "@testing-library/user-event": "^14.6.1",
    "@types/autosuggest-highlight": "^3.2.3",
    "@types/css-mediaquery": "^0.1.4",
    "@types/file-saver": "^2.0.7",
    "@types/google.analytics": "^0.0.46",
    "@types/js-cookie": "^3.0.6",
    "@types/lodash": "^4.17.24",
    "@types/node": "^26.1.2",
    "@types/react": "19.2.18",
    "@types/react-dom": "19.2.4",
    "@types/react-places-autocomplete": "^7.2.14",
    "@typescript-eslint/eslint-plugin": "^8.65.0",
    "@typescript-eslint/parser": "^8.65.0",
    "@vitejs/plugin-react-swc": "^4.3.3",
    "@vitest/coverage-v8": "^4.1.10",
    "@vitest/eslint-plugin": "^1.6.26",
    "css-mediaquery": "^0.1.2",
    "eslint": "^9.39.5",
    "eslint-config-google": "^0.14.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.1.1",
    "globals": "^17.9.0",
    "happy-dom": "^20.14.5",
    "husky": "^9.1.7",
    "lint-staged": "^17.3.0",
    "msw": "^2.15.0",
    "prettier": "^3.9.6",
    "typescript": "^6.0.3",
    "vite": "^8.2.0",
    "vite-plugin-checker": "^0.14.5",
    "vite-plugin-svgr": "^5.2.0",
    "vitest": "^4.1.10"
  }
}
